import jsPDF from "jspdf";
import employeeLogo from "../../images/employee.png";

export const UpdatePurchasePrint = ({ obj }) => {
  let { selectedVendor, state, ledger_detail, user, Total, remaining } = obj;
  let doc = new jsPDF();

  doc.setFontSize(18);
  doc.setFontStyle("bold");
  doc.text(localStorage.getItem("company"), 105, 22);
  doc.setFontSize(26);
  doc.text("PURCHASE ORDER", 105, 35);

  doc.setFontSize(12);
  doc.setFontStyle("normal");

  doc.text("Date:", 150, 45);
  doc.text(state.date, 165, 45);

  if (selectedVendor) {
    doc.setFontSize(14);
    doc.setFontStyle("bold");
    doc.text("SHIP TO", 100, 48);

    doc.text("VENDOR", 21, 48);
    doc.setFontSize(12);
    doc.setFontStyle("normal");
    doc.text(selectedVendor?.companyName, 20, 55);
    doc.text(selectedVendor?.dept || "", 20, 60);
    doc.text(selectedVendor?.street || "", 20, 65);
    doc.text(selectedVendor?.city || "", 20, 70);
    doc.text(selectedVendor?.phone || "", 20, 75);
  } else {
    doc.setFontSize(14);
    doc.setFontStyle("bold");
    doc.text("SHIP TO", 100, 48);
    doc.text("LEDGER", 21, 48);
    doc.setFontSize(12);
    doc.setFontStyle("normal");

    doc.text(ledger_detail?.name || "", 20, 55);
    doc.text(ledger_detail?.address || "", 20, 60);
    doc.text(ledger_detail?.ledgerType || "", 20, 65);
  }

  doc.text(user?.name || "", 100, 55);
  doc.text(user?.company || "", 100, 60);
  doc.text(user?.street || "", 100, 65);
  doc.text(user?.city || "", 100, 70);
  doc.text(user?.phone || "", 100, 75);

  doc.setFontSize(14);
  doc.setFontStyle("bold");
  doc.text("Sr #", 21, 90);
  doc.text("Item", 40, 90);
  doc.text("Description", 80, 90);
  doc.text("Quantity", 140, 90);
  doc.text("Price", 170, 90);
  doc.cell(20, 84, 170, 8, " ");
  let y = 92;
  state.items.map((item, index) => {
    let itemPrice = item.newPrice
      ? parseInt(item.newPrice)
      : parseInt(item.companyPrice);
    let qty = item.newQuantity ? parseInt(item.newQuantity) : 1;
    doc.setFontSize(14);
    doc.setFontStyle("bold");
    doc.cell(20, y, 12, 6, " ");
    doc.cell(32, y, 35, 6, " ");
    doc.cell(67, y, 70, 6, " ");
    doc.cell(137, y, 25, 6, " ");
    doc.cell(162, y, 28, 6, " ");

    doc.setFontSize(12);
    doc.setFontStyle("normal");
    doc.text((index + 1).toString(), 22, y + 5);
    doc.text(item.name, 34, y + 5);
    doc.text(item.description, 69, y + 5);
    doc.text(itemPrice.toString(), 170, y + 5);
    doc.text(qty.toString(), 139, y + 5);
    y = y + 6;
    doc.setFontSize(10);

    doc.text(localStorage.getItem("terms") || "", 65, 270);

    doc.text("Powered by www.hardwarepakistan.com", 75, 280);
    doc.text("0342-5588269", 85, 290);

    if (y >= 240) {
      doc.addPage();
      y = 20;
    }
  });

  y = y + 8;

  doc.cell(20, y, 100, 8, " ");
  doc.cell(20, y + 8, 100, 30, " ");

  doc.setFontSize(14);
  doc.text("Comments Or Special Instructions", 22, y + 6);
  doc.text("TOTAL", 138, y);
  doc.text("PAID", 138, y + 7);
  doc.text("REMAINING", 138, y + 14);
  doc.text(Total.toString(), 168, y);
  doc.text(state.paid.toString(), 168, y + 7);

  let rems = remaining - state.paid;
  doc.text(rems.toString(), 168, y + 14);
  y = y + 23;

  let img = new Image();

  let baseUrl = localStorage.getItem("base_url");

  if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
    let snapshot = employeeLogo;
    img.src = snapshot;
  } else {
    let snapshot = localStorage.getItem("base_url");
    img.src = snapshot;
  }
  doc.addImage(img, "png", 0, 0, 40, 40);

  if (window.innerWidth <= 600) {
    doc.save("reciept");
  } else {
    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");
  }
};
